// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"rgba%28255,255,255,0.1%29\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"rgba%28255,255,255,0.1%29\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StoreForm_store-form-container__DSkVI {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background: #f5f5f5;
  min-height: 100vh;
  position: relative;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m h2 {
  color: #2c3e50;
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_unsaved-indicator__uAgWq {
  color: #e74c3c;
  font-weight: 600;
  font-size: 0.9rem;
  animation: StoreForm_pulse__S3Wb8 2s infinite;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_last-saved__yiAKp {
  color: #27ae60;
  font-size: 0.85rem;
  font-weight: 500;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_restore-btn__dHLgW,
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_save-btn__ZLXd6,
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_template-btn__QxYy8,
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-btn__OfvY5 {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_restore-btn__dHLgW {
  background: #f39c12;
  color: white;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_restore-btn__dHLgW:hover:not(:disabled) {
  background: #e67e22;
  transform: translateY(-1px);
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_restore-btn__dHLgW:disabled {
  background: #bdc3c7;
  color: #7f8c8d;
  cursor: not-allowed;
  transform: none;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_save-btn__ZLXd6 {
  background: #27ae60;
  color: white;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_save-btn__ZLXd6:hover {
  background: #229954;
  transform: translateY(-1px);
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_template-btn__QxYy8 {
  background: #3498db;
  color: white;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_template-btn__QxYy8:hover {
  background: #2980b9;
  transform: translateY(-1px);
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-section__0qzAN {
  position: relative;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-section__0qzAN .StoreForm_upload-btn__OfvY5 {
  background: #9b59b6;
  color: white;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-section__0qzAN .StoreForm_upload-btn__OfvY5:hover {
  background: #8e44ad;
  transform: translateY(-1px);
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-section__0qzAN .StoreForm_upload-btn__OfvY5.StoreForm_uploading__M4Ky2 {
  background: #95a5a6;
  cursor: not-allowed;
  opacity: 0.7;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-status__lQhM3 {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-status__lQhM3.StoreForm_success__8Nvdd {
  background: #d5f4e6;
  color: #27ae60;
  border: 1px solid #a8e6cf;
}
.StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_upload-status__lQhM3.StoreForm_error__X1b3K {
  background: #fadbd8;
  color: #e74c3c;
  border: 1px solid #f1948a;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  color: white;
  position: relative;
  overflow: hidden;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.3;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI {
    flex-direction: column;
    gap: 15px;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-left__dbz14 .StoreForm_university-name__uGHzX {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-left__dbz14 .StoreForm_university-name__uGHzX {
    font-size: 1.5rem;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-left__dbz14 .StoreForm_office-name__ojrno {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 6px;
  opacity: 0.95;
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-left__dbz14 .StoreForm_office-name__ojrno {
    font-size: 1rem;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-left__dbz14 .StoreForm_office-code__I\\+dIJ {
  font-size: 0.95rem;
  opacity: 0.9;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-left__dbz14 .StoreForm_office-code__I\\+dIJ .StoreForm_code-value__lwWbo {
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 5px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V {
  text-align: right;
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V {
    text-align: left;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_form-number__inyUw {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 6px;
  background: rgba(255, 255, 255, 0.15);
  padding: 8px 12px;
  border-radius: 6px;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 8px;
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_form-number__inyUw {
    font-size: 1rem;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_form-number__inyUw .StoreForm_header-input__Ue\\+fr {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  padding: 4px 8px;
  color: white;
  font-size: 0.9rem;
  width: 60px;
  text-align: center;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_form-number__inyUw .StoreForm_header-input__Ue\\+fr::placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_form-number__inyUw .StoreForm_header-input__Ue\\+fr:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.25);
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_previous-form__21s8i {
  font-size: 0.9rem;
  opacity: 0.85;
  background: rgba(255, 255, 255, 0.1);
  padding: 6px 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_previous-form__21s8i .StoreForm_header-input__Ue\\+fr {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  padding: 4px 8px;
  color: white;
  font-size: 0.8rem;
  width: 50px;
  text-align: center;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_previous-form__21s8i .StoreForm_header-input__Ue\\+fr::placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_header-top__dQNUI .StoreForm_header-right__FmV2V .StoreForm_previous-form__21s8i .StoreForm_header-input__Ue\\+fr:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.25);
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_main-title__HpFHU {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 25px 0;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 2;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_main-title__HpFHU {
    font-size: 1.3rem;
    padding: 12px;
  }
}
@media (max-width: 480px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_main-title__HpFHU {
    font-size: 1.1rem;
    padding: 10px;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_fiscal-year__Cg3Mf {
  font-size: 1rem;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.15);
  padding: 8px 12px;
  border-radius: 6px;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  gap: 8px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_fiscal-year__Cg3Mf .StoreForm_header-input__Ue\\+fr {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  padding: 4px 8px;
  color: #ffd700;
  font-size: 0.9rem;
  font-weight: 700;
  width: 80px;
  text-align: center;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_fiscal-year__Cg3Mf .StoreForm_header-input__Ue\\+fr::placeholder {
  color: rgba(255, 215, 0, 0.7);
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_fiscal-year__Cg3Mf .StoreForm_header-input__Ue\\+fr:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.25);
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_inventory-info__IBcs4 {
  display: flex;
  gap: 20px;
  font-size: 0.9rem;
  opacity: 0.9;
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_inventory-info__IBcs4 {
    flex-direction: column;
    gap: 8px;
  }
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_inventory-info__IBcs4 span {
  background: rgba(255, 255, 255, 0.1);
  padding: 6px 10px;
  border-radius: 4px;
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  gap: 6px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_inventory-info__IBcs4 span .StoreForm_header-input__Ue\\+fr {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  padding: 3px 6px;
  color: white;
  font-size: 0.8rem;
  width: 60px;
  text-align: center;
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_inventory-info__IBcs4 span .StoreForm_header-input__Ue\\+fr::placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.StoreForm_store-form-container__DSkVI .StoreForm_official-header__keK1W .StoreForm_sub-header__1ozvf .StoreForm_inventory-info__IBcs4 span .StoreForm_header-input__Ue\\+fr:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.25);
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid #e3f2fd;
  border-radius: 12px;
  margin: 20px 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(52, 152, 219, 0.1);
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12), 0 3px 12px rgba(52, 152, 219, 0.15);
  transform: translateY(-2px);
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #3498db 0%, #2980b9 100%);
  box-shadow: 0 0 8px rgba(52, 152, 219, 0.3);
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #e8f4fd;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr:last-child {
  border-bottom: none;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr:hover {
  background: rgba(52, 152, 219, 0.02);
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a {
  padding: 15px 20px;
  display: flex;
  align-items: center;
  min-height: 50px;
  transition: all 0.2s ease;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a:first-child {
  border-right: 1px solid #e8f4fd;
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
  font-weight: 600;
  position: relative;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a:first-child::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 60%;
  background: linear-gradient(180deg, transparent 0%, #3498db 50%, transparent 100%);
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_nepali-text__GO5hX {
  font-size: 1rem;
  color: #2c3e50;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  letter-spacing: 0.5px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_english-text__5XRwp {
  font-size: 1.1rem;
  color: #2c3e50;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_table-input__4b8fS {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 15px;
  font-size: 1rem;
  color: #2c3e50;
  width: 100%;
  max-width: 250px;
  transition: all 0.3s ease;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_table-input__4b8fS::placeholder {
  color: #95a5a6;
  font-style: italic;
  font-size: 0.9rem;
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_table-input__4b8fS:hover {
  border-color: #bdc3c7;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
}
.StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_table-input__4b8fS:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15), inset 0 1px 3px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}
@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh {
    border-radius: 8px;
    margin: 15px 0;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr {
    grid-template-columns: 1fr;
    border-bottom: 1px solid #e8f4fd;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a {
    padding: 12px 15px;
    min-height: 45px;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a:first-child {
    border-right: none;
    border-bottom: 1px solid #e8f4fd;
    background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a:first-child::after {
    display: none;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_nepali-text__GO5hX {
    font-size: 0.95rem;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_table-header__ytNyh .StoreForm_table-row__necnr .StoreForm_table-cell__p29\\+a .StoreForm_table-input__4b8fS {
    max-width: 100%;
    padding: 8px 12px;
    font-size: 0.95rem;
  }
}

.StoreForm_store-form__TezP0 {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 35px;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08), 0 4px 15px rgba(52, 152, 219, 0.1);
  border: 2px solid #e3f2fd;
  transition: all 0.3s ease;
}
.StoreForm_store-form__TezP0:hover {
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(52, 152, 219, 0.15);
}

.StoreForm_form-grid__LeD44 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.StoreForm_form-group__uSERQ {
  display: flex;
  flex-direction: column;
  position: relative;
}
.StoreForm_form-group__uSERQ.StoreForm_full-width__zCoGK {
  grid-column: 1/-1;
}
.StoreForm_form-group__uSERQ label {
  margin-bottom: 8px;
  font-weight: 600;
  color: #34495e;
  font-size: 0.9rem;
  text-align: left;
}
.StoreForm_form-group__uSERQ input,
.StoreForm_form-group__uSERQ textarea {
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #ffffff;
  color: #2c3e50;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}
.StoreForm_form-group__uSERQ input:hover,
.StoreForm_form-group__uSERQ textarea:hover {
  border-color: #bdc3c7;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
}
.StoreForm_form-group__uSERQ input:focus,
.StoreForm_form-group__uSERQ textarea:focus {
  outline: none;
  border-color: #3498db;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15), inset 0 1px 3px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}
.StoreForm_form-group__uSERQ textarea {
  resize: vertical;
  min-height: 80px;
}
.StoreForm_form-group__uSERQ input[name=miti],
.StoreForm_form-group__uSERQ input[name=miti_nepali] {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.StoreForm_form-group__uSERQ input[name=miti]::placeholder,
.StoreForm_form-group__uSERQ input[name=miti_nepali]::placeholder {
  color: #95a5a6;
  font-style: italic;
}
.StoreForm_form-group__uSERQ input[name=miti_nepali] {
  padding-right: 45px;
}
.StoreForm_form-group__uSERQ .StoreForm_calendar-btn__tb-va {
  position: absolute;
  right: 8px;
  top: 65%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  z-index: 10;
}
.StoreForm_form-group__uSERQ .StoreForm_calendar-btn__tb-va:hover {
  background-color: #f0f0f0;
}
.StoreForm_form-group__uSERQ .StoreForm_readonly-input__tbHDv {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  cursor: not-allowed;
}
.StoreForm_form-group__uSERQ .StoreForm_readonly-input__tbHDv:focus {
  border-color: #d5d5d5 !important;
  box-shadow: none !important;
}
.StoreForm_form-group__uSERQ .StoreForm_input-hint__r7aYd {
  color: #7f8c8d;
  font-size: 0.8rem;
  font-style: italic;
  margin-top: 4px;
  padding: 4px 8px;
  background: #ecf0f1;
  border-radius: 4px;
  border-left: 3px solid #3498db;
  line-height: 1.3;
}
.StoreForm_form-group__uSERQ .StoreForm_calendar-popup__DhUqu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  border: 2px solid #3498db;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  margin-top: 5px;
}
.StoreForm_form-group__uSERQ .StoreForm_help-text__NrAlX {
  font-size: 0.75rem;
  color: #7f8c8d;
  margin-top: 4px;
  font-style: italic;
}
.StoreForm_form-group__uSERQ.StoreForm_date-field__RqIlt {
  margin-bottom: 0;
}

.StoreForm_form-actions__yQd7T {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.StoreForm_submit-btn__CjfnF,
.StoreForm_reset-btn__-H-mq {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.StoreForm_submit-btn__CjfnF {
  background: #3498db;
  color: white;
  font-weight: 600;
}
.StoreForm_submit-btn__CjfnF:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
}
.StoreForm_submit-btn__CjfnF:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.StoreForm_reset-btn__-H-mq {
  background: #95a5a6;
  color: white;
  font-weight: 600;
}
.StoreForm_reset-btn__-H-mq:hover {
  background: #7f8c8d;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(149, 165, 166, 0.3);
}

.StoreForm_message__Uoi4h {
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
  text-align: center;
  font-weight: 500;
}
.StoreForm_message__Uoi4h.StoreForm_success__8Nvdd {
  background: #d5f4e6;
  color: #27ae60;
  border: 1px solid #a8e6cf;
}
.StoreForm_message__Uoi4h.StoreForm_error__X1b3K {
  background: #fadbd8;
  color: #e74c3c;
  border: 1px solid #f1948a;
}

@media (max-width: 768px) {
  .StoreForm_store-form-container__DSkVI {
    padding: 10px;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m h2 {
    font-size: 1.5rem;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe {
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
  }
  .StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_restore-btn__dHLgW,
  .StoreForm_store-form-container__DSkVI .StoreForm_form-header__cER0m .StoreForm_storage-controls__SBjhe .StoreForm_save-btn__ZLXd6 {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
  .StoreForm_store-form__TezP0 {
    padding: 20px;
  }
  .StoreForm_form-grid__LeD44 {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .StoreForm_form-actions__yQd7T {
    flex-direction: column;
    align-items: center;
  }
  .StoreForm_submit-btn__CjfnF,
  .StoreForm_reset-btn__-H-mq {
    width: 100%;
    max-width: 300px;
  }
}
@media (max-width: 480px) {
  .StoreForm_store-form__TezP0 {
    padding: 15px;
  }
  .StoreForm_form-group__uSERQ input,
  .StoreForm_form-group__uSERQ textarea {
    padding: 10px;
    font-size: 0.9rem;
  }
  .StoreForm_form-group__uSERQ label {
    font-size: 0.8rem;
  }
}
.StoreForm_edit-mode-indicator__yH07a {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: StoreForm_pulse__S3Wb8 2s infinite;
}

.StoreForm_saved-indicator__-3IQK {
  background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@keyframes StoreForm_pulse__S3Wb8 {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/store-form/StoreForm.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,4DAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AACR;AACQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AACZ;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAAZ;AAEY;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,6CAAA;AAAhB;AAGY;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AADhB;AAIY;;;;EAII,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAFhB;AAKY;EACI,mBAAA;EACA,YAAA;AAHhB;AAKgB;EACI,mBAAA;EACA,2BAAA;AAHpB;AAMgB;EACI,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAJpB;AAQY;EACI,mBAAA;EACA,YAAA;AANhB;AAQgB;EACI,mBAAA;EACA,2BAAA;AANpB;AAUY;EACI,mBAAA;EACA,YAAA;AARhB;AAUgB;EACI,mBAAA;EACA,2BAAA;AARpB;AAYY;EACI,kBAAA;AAVhB;AAYgB;EACI,mBAAA;EACA,YAAA;AAVpB;AAYoB;EACI,mBAAA;EACA,2BAAA;AAVxB;AAaoB;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;AAXxB;AAgBY;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAdhB;AAgBgB;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAdpB;AAiBgB;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAfpB;AAsBI;EACI,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AApBR;AAsBQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mDAAA;EACA,YAAA;AApBZ;AAuBQ;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AArBZ;AAuBY;EARJ;IASQ,sBAAA;IACA,SAAA;EApBd;AACF;AAuBgB;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;AArBpB;AAuBoB;EAPJ;IAQQ,iBAAA;EApBtB;AACF;AAuBgB;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AArBpB;AAuBoB;EANJ;IAOQ,eAAA;EApBtB;AACF;AAuBgB;EACI,kBAAA;EACA,YAAA;AArBpB;AAuBoB;EACI,gBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AArBxB;AA0BY;EACI,iBAAA;AAxBhB;AA0BgB;EAHJ;IAIQ,gBAAA;EAvBlB;AACF;AAyBiC;EACZ,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAvBrB;AAyBqB;EAZY;IAaR,eAAA;EAtBvB;AACF;AAwBqB;EACI,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAtBzB;AAwByB;EACI,+BAAA;AAtB7B;AAyByB;EACI,aAAA;EACA,sCAAA;EACA,qCAAA;AAvB7B;AA4BiB;EACI,iBAAA;EACA,aAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA1BrB;AA4BqB;EACI,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AA1BzB;AA4ByB;EACI,+BAAA;AA1B7B;AA6ByB;EACI,aAAA;EACA,sCAAA;EACA,qCAAA;AA3B7B;AAkCQ;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,2BAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;EACA,2CAAA;AAhCZ;AAkCY;EAdJ;IAeQ,iBAAA;IACA,aAAA;EA/Bd;AACF;AAiCY;EAnBJ;IAoBQ,iBAAA;IACA,aAAA;EA9Bd;AACF;AAiCQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AA/BZ;AAiCY;EAPJ;IAQQ,sBAAA;IACA,SAAA;IACA,uBAAA;EA9Bd;AACF;AAgCyB;EACR,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA9BjB;AAgCiB;EACI,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AA9BrB;AAgCqB;EACI,6BAAA;AA9BzB;AAiCqB;EACI,aAAA;EACA,sCAAA;EACA,qCAAA;AA/BzB;AAoCY;EACI,aAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAlChB;AAoCgB;EANJ;IAOQ,sBAAA;IACA,QAAA;EAjClB;AACF;AAmCiC;EACZ,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjCrB;AAmCqB;EACI,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAjCzB;AAmCyB;EACI,+BAAA;AAjC7B;AAoCyB;EACI,aAAA;EACA,sCAAA;EACA,qCAAA;AAlC7B;AA2CI;EACI,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,6EAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAzCR;AA2CQ;EACI,+EAAA;EACA,2BAAA;AAzCZ;AA4CQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,6DAAA;EACA,2CAAA;AA1CZ;AA6CQ;EACI,aAAA;EACA,8BAAA;EACA,gCAAA;AA3CZ;AA6CY;EACI,mBAAA;AA3ChB;AA8CY;EACI,oCAAA;AA5ChB;AA+CY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AA7ChB;AA+CgB;EACI,+BAAA;EACA,6DAAA;EACA,gBAAA;EACA,kBAAA;AA7CpB;AA+CoB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kFAAA;AA7CxB;AAiDgB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,0CAAA;EACA,qBAAA;AA/CpB;AAkDgB;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAhDpB;AAmDgB;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,+CAAA;AAjDpB;AAmDoB;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;AAjDxB;AAoDoB;EACI,qBAAA;EACA,+CAAA;AAlDxB;AAqDoB;EACI,aAAA;EACA,qBAAA;EACA,mFAAA;EACA,2BAAA;AAnDxB;AAyDQ;EAjHJ;IAkHQ,kBAAA;IACA,cAAA;EAtDV;EAwDU;IACI,0BAAA;IACA,gCAAA;EAtDd;EAwDc;IACI,kBAAA;IACA,gBAAA;EAtDlB;EAwDkB;IACI,kBAAA;IACA,gCAAA;IACA,6DAAA;EAtDtB;EAwDsB;IACI,aAAA;EAtD1B;EA0DkB;IACI,kBAAA;EAxDtB;EA2DkB;IACI,eAAA;IACA,iBAAA;IACA,kBAAA;EAzDtB;AACF;;AAgEA;EACI,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,8EAAA;EACA,yBAAA;EACA,yBAAA;AA7DJ;AA+DI;EACI,gFAAA;AA7DR;;AAiEA;EACI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AA9DJ;;AAiEA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AA9DJ;AAgEI;EACI,iBAAA;AA9DR;AAiEI;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA/DR;AAkEI;;EAEI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,+CAAA;AAhER;AAkEQ;;EACI,qBAAA;EACA,+CAAA;AA/DZ;AAkEQ;;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,mFAAA;EACA,2BAAA;AA/DZ;AAmEI;EACI,gBAAA;EACA,gBAAA;AAjER;AAoEI;;EAEI,4DAAA;AAlER;AAoEQ;;EACI,cAAA;EACA,kBAAA;AAjEZ;AAqEI;EACI,mBAAA;AAnER;AAsEI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;EACA,WAAA;AApER;AAsEQ;EACI,yBAAA;AApEZ;AAwEI;EACI,oCAAA;EACA,yBAAA;EACA,mBAAA;AAtER;AAwEQ;EACI,gCAAA;EACA,2BAAA;AAtEZ;AA0EI;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AAxER;AA2EI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;AAzER;AA4EI;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA1ER;AA6EI;EACI,gBAAA;AA3ER;;AA+EA;EACI,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AA5EJ;;AA+EA;;EAEI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA5EJ;;AA+EA;EACI,mBAAA;EACA,YAAA;EACA,gBAAA;AA5EJ;AA8EI;EACI,mBAAA;EACA,2BAAA;EACA,6CAAA;AA5ER;AA+EI;EACI,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA7ER;;AAiFA;EACI,mBAAA;EACA,YAAA;EACA,gBAAA;AA9EJ;AAgFI;EACI,mBAAA;EACA,2BAAA;EACA,8CAAA;AA9ER;;AAkFA;EACI,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA/EJ;AAiFI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AA/ER;AAkFI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAhFR;;AAoFA;EACI;IACI,aAAA;EAjFN;EAmFM;IACI,sBAAA;IACA,uBAAA;IACA,SAAA;EAjFV;EAmFU;IACI,iBAAA;EAjFd;EAoFU;IACI,WAAA;IACA,2BAAA;IACA,QAAA;EAlFd;EAoFc;;IAEI,iBAAA;IACA,iBAAA;EAlFlB;EAwFE;IACI,aAAA;EAtFN;EAyFE;IACI,0BAAA;IACA,SAAA;EAvFN;EA0FE;IACI,sBAAA;IACA,mBAAA;EAxFN;EA2FE;;IAEI,WAAA;IACA,gBAAA;EAzFN;AACF;AA4FA;EACI;IACI,aAAA;EA1FN;EA8FM;;IAEI,aAAA;IACA,iBAAA;EA5FV;EA+FM;IACI,iBAAA;EA7FV;AACF;AAiGA;EACI,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,6CAAA;AA/FJ;;AAkGA;EACI,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;AA/FJ;;AAkGA;EACI;IAAK,UAAA;EA9FP;EA+FE;IAAM,YAAA;EA5FR;EA6FE;IAAO,UAAA;EA1FT;AACF","sourcesContent":[".store-form-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background: #f5f5f5;\n    min-height: 100vh;\n    position: relative;\n\n    .form-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 20px;\n        flex-wrap: wrap;\n        gap: 15px;\n\n        h2 {\n            color: #2c3e50;\n            font-size: 2rem;\n            font-weight: 600;\n            margin: 0;\n        }\n\n        .storage-controls {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            flex-wrap: wrap;\n\n            .unsaved-indicator {\n                color: #e74c3c;\n                font-weight: 600;\n                font-size: 0.9rem;\n                animation: pulse 2s infinite;\n            }\n\n            .last-saved {\n                color: #27ae60;\n                font-size: 0.85rem;\n                font-weight: 500;\n            }\n\n            .restore-btn,\n            .save-btn,\n            .template-btn,\n            .upload-btn {\n                padding: 8px 16px;\n                border: none;\n                border-radius: 6px;\n                font-size: 0.9rem;\n                font-weight: 600;\n                cursor: pointer;\n                transition: all 0.3s ease;\n                display: flex;\n                align-items: center;\n                gap: 5px;\n            }\n\n            .restore-btn {\n                background: #f39c12;\n                color: white;\n\n                &:hover:not(:disabled) {\n                    background: #e67e22;\n                    transform: translateY(-1px);\n                }\n\n                &:disabled {\n                    background: #bdc3c7;\n                    color: #7f8c8d;\n                    cursor: not-allowed;\n                    transform: none;\n                }\n            }\n\n            .save-btn {\n                background: #27ae60;\n                color: white;\n\n                &:hover {\n                    background: #229954;\n                    transform: translateY(-1px);\n                }\n            }\n\n            .template-btn {\n                background: #3498db;\n                color: white;\n\n                &:hover {\n                    background: #2980b9;\n                    transform: translateY(-1px);\n                }\n            }\n\n            .upload-section {\n                position: relative;\n\n                .upload-btn {\n                    background: #9b59b6;\n                    color: white;\n\n                    &:hover {\n                        background: #8e44ad;\n                        transform: translateY(-1px);\n                    }\n\n                    &.uploading {\n                        background: #95a5a6;\n                        cursor: not-allowed;\n                        opacity: 0.7;\n                    }\n                }\n            }\n\n            .upload-status {\n                margin-top: 10px;\n                padding: 8px 12px;\n                border-radius: 4px;\n                font-size: 0.85rem;\n                font-weight: 500;\n\n                &.success {\n                    background: #d5f4e6;\n                    color: #27ae60;\n                    border: 1px solid #a8e6cf;\n                }\n\n                &.error {\n                    background: #fadbd8;\n                    color: #e74c3c;\n                    border: 1px solid #f1948a;\n                }\n            }\n        }\n    }\n\n    // Official Header Section - Beautiful and Responsive\n    .official-header {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        border-radius: 12px;\n        padding: 25px;\n        margin-bottom: 30px;\n        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n        color: white;\n        position: relative;\n        overflow: hidden;\n\n        &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"rgba(255,255,255,0.1)\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"rgba(255,255,255,0.1)\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n            opacity: 0.3;\n        }\n\n        .header-top {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n            margin-bottom: 20px;\n            position: relative;\n            z-index: 2;\n\n            @media (max-width: 768px) {\n                flex-direction: column;\n                gap: 15px;\n            }\n\n            .header-left {\n                .university-name {\n                    font-size: 1.8rem;\n                    font-weight: 700;\n                    margin-bottom: 8px;\n                    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n                    letter-spacing: 1px;\n\n                    @media (max-width: 768px) {\n                        font-size: 1.5rem;\n                    }\n                }\n\n                .office-name {\n                    font-size: 1.2rem;\n                    font-weight: 600;\n                    margin-bottom: 6px;\n                    opacity: 0.95;\n\n                    @media (max-width: 768px) {\n                        font-size: 1rem;\n                    }\n                }\n\n                .office-code {\n                    font-size: 0.95rem;\n                    opacity: 0.9;\n\n                    .code-value {\n                        font-weight: 600;\n                        background: rgba(255, 255, 255, 0.2);\n                        padding: 2px 8px;\n                        border-radius: 4px;\n                        margin-left: 5px;\n                    }\n                }\n            }\n\n            .header-right {\n                text-align: right;\n\n                @media (max-width: 768px) {\n                    text-align: left;\n                }\n\n                                 .form-number {\n                     font-size: 1.1rem;\n                     font-weight: 600;\n                     margin-bottom: 6px;\n                     background: rgba(255, 255, 255, 0.15);\n                     padding: 8px 12px;\n                     border-radius: 6px;\n                     backdrop-filter: blur(10px);\n                     display: flex;\n                     align-items: center;\n                     gap: 8px;\n\n                     @media (max-width: 768px) {\n                         font-size: 1rem;\n                     }\n\n                     .header-input {\n                         background: rgba(255, 255, 255, 0.2);\n                         border: 1px solid rgba(255, 255, 255, 0.3);\n                         border-radius: 4px;\n                         padding: 4px 8px;\n                         color: white;\n                         font-size: 0.9rem;\n                         width: 60px;\n                         text-align: center;\n\n                         &::placeholder {\n                             color: rgba(255, 255, 255, 0.7);\n                         }\n\n                         &:focus {\n                             outline: none;\n                             border-color: rgba(255, 255, 255, 0.5);\n                             background: rgba(255, 255, 255, 0.25);\n                         }\n                     }\n                 }\n\n                 .previous-form {\n                     font-size: 0.9rem;\n                     opacity: 0.85;\n                     background: rgba(255, 255, 255, 0.1);\n                     padding: 6px 10px;\n                     border-radius: 4px;\n                     display: flex;\n                     align-items: center;\n                     gap: 8px;\n\n                     .header-input {\n                         background: rgba(255, 255, 255, 0.2);\n                         border: 1px solid rgba(255, 255, 255, 0.3);\n                         border-radius: 4px;\n                         padding: 4px 8px;\n                         color: white;\n                         font-size: 0.8rem;\n                         width: 50px;\n                         text-align: center;\n\n                         &::placeholder {\n                             color: rgba(255, 255, 255, 0.7);\n                         }\n\n                         &:focus {\n                             outline: none;\n                             border-color: rgba(255, 255, 255, 0.5);\n                             background: rgba(255, 255, 255, 0.25);\n                         }\n                     }\n                 }\n            }\n        }\n\n        .main-title {\n            text-align: center;\n            font-size: 1.6rem;\n            font-weight: 700;\n            margin: 25px 0;\n            padding: 15px;\n            background: rgba(255, 255, 255, 0.1);\n            border-radius: 8px;\n            backdrop-filter: blur(10px);\n            border: 1px solid rgba(255, 255, 255, 0.2);\n            position: relative;\n            z-index: 2;\n            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n\n            @media (max-width: 768px) {\n                font-size: 1.3rem;\n                padding: 12px;\n            }\n\n            @media (max-width: 480px) {\n                font-size: 1.1rem;\n                padding: 10px;\n            }\n        }\n\n        .sub-header {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            position: relative;\n            z-index: 2;\n\n            @media (max-width: 768px) {\n                flex-direction: column;\n                gap: 10px;\n                align-items: flex-start;\n            }\n\n                         .fiscal-year {\n                 font-size: 1rem;\n                 font-weight: 600;\n                 background: rgba(255, 255, 255, 0.15);\n                 padding: 8px 12px;\n                 border-radius: 6px;\n                 backdrop-filter: blur(10px);\n                 display: flex;\n                 align-items: center;\n                 gap: 8px;\n\n                 .header-input {\n                     background: rgba(255, 255, 255, 0.2);\n                     border: 1px solid rgba(255, 255, 255, 0.3);\n                     border-radius: 4px;\n                     padding: 4px 8px;\n                     color: #ffd700;\n                     font-size: 0.9rem;\n                     font-weight: 700;\n                     width: 80px;\n                     text-align: center;\n\n                     &::placeholder {\n                         color: rgba(255, 215, 0, 0.7);\n                     }\n\n                     &:focus {\n                         outline: none;\n                         border-color: rgba(255, 255, 255, 0.5);\n                         background: rgba(255, 255, 255, 0.25);\n                     }\n                 }\n             }\n\n            .inventory-info {\n                display: flex;\n                gap: 20px;\n                font-size: 0.9rem;\n                opacity: 0.9;\n\n                @media (max-width: 768px) {\n                    flex-direction: column;\n                    gap: 8px;\n                }\n\n                                 span {\n                     background: rgba(255, 255, 255, 0.1);\n                     padding: 6px 10px;\n                     border-radius: 4px;\n                     backdrop-filter: blur(5px);\n                     display: flex;\n                     align-items: center;\n                     gap: 6px;\n\n                     .header-input {\n                         background: rgba(255, 255, 255, 0.2);\n                         border: 1px solid rgba(255, 255, 255, 0.3);\n                         border-radius: 3px;\n                         padding: 3px 6px;\n                         color: white;\n                         font-size: 0.8rem;\n                         width: 60px;\n                         text-align: center;\n\n                         &::placeholder {\n                             color: rgba(255, 255, 255, 0.7);\n                         }\n\n                         &:focus {\n                             outline: none;\n                             border-color: rgba(255, 255, 255, 0.5);\n                             background: rgba(255, 255, 255, 0.25);\n                         }\n                     }\n                 }\n            }\n        }\n    }\n\n    // Table Header Section\n    .table-header {\n        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n        border: 2px solid #e3f2fd;\n        border-radius: 12px;\n        margin: 20px 0;\n        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(52, 152, 219, 0.1);\n        overflow: hidden;\n        position: relative;\n        transition: all 0.3s ease;\n\n        &:hover {\n            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12), 0 3px 12px rgba(52, 152, 219, 0.15);\n            transform: translateY(-2px);\n        }\n\n        &::before {\n            content: '';\n            position: absolute;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            width: 4px;\n            background: linear-gradient(180deg, #3498db 0%, #2980b9 100%);\n            box-shadow: 0 0 8px rgba(52, 152, 219, 0.3);\n        }\n\n        .table-row {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            border-bottom: 1px solid #e8f4fd;\n\n            &:last-child {\n                border-bottom: none;\n            }\n\n            &:hover {\n                background: rgba(52, 152, 219, 0.02);\n            }\n\n            .table-cell {\n                padding: 15px 20px;\n                display: flex;\n                align-items: center;\n                min-height: 50px;\n                transition: all 0.2s ease;\n\n                &:first-child {\n                    border-right: 1px solid #e8f4fd;\n                    background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);\n                    font-weight: 600;\n                    position: relative;\n\n                    &::after {\n                        content: '';\n                        position: absolute;\n                        right: 0;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        width: 1px;\n                        height: 60%;\n                        background: linear-gradient(180deg, transparent 0%, #3498db 50%, transparent 100%);\n                    }\n                }\n\n                .nepali-text {\n                    font-size: 1rem;\n                    color: #2c3e50;\n                    font-weight: 600;\n                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n                    letter-spacing: 0.5px;\n                }\n\n                .english-text {\n                    font-size: 1.1rem;\n                    color: #2c3e50;\n                    font-weight: 700;\n                    text-transform: uppercase;\n                    letter-spacing: 1px;\n                }\n\n                .table-input {\n                    background: white;\n                    border: 2px solid #e0e0e0;\n                    border-radius: 8px;\n                    padding: 10px 15px;\n                    font-size: 1rem;\n                    color: #2c3e50;\n                    width: 100%;\n                    max-width: 250px;\n                    transition: all 0.3s ease;\n                    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n\n                    &::placeholder {\n                        color: #95a5a6;\n                        font-style: italic;\n                        font-size: 0.9rem;\n                    }\n\n                    &:hover {\n                        border-color: #bdc3c7;\n                        box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);\n                    }\n\n                    &:focus {\n                        outline: none;\n                        border-color: #3498db;\n                        box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15), inset 0 1px 3px rgba(0, 0, 0, 0.05);\n                        transform: translateY(-1px);\n                    }\n                }\n            }\n        }\n\n        @media (max-width: 768px) {\n            border-radius: 8px;\n            margin: 15px 0;\n\n            .table-row {\n                grid-template-columns: 1fr;\n                border-bottom: 1px solid #e8f4fd;\n\n                .table-cell {\n                    padding: 12px 15px;\n                    min-height: 45px;\n\n                    &:first-child {\n                        border-right: none;\n                        border-bottom: 1px solid #e8f4fd;\n                        background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);\n\n                        &::after {\n                            display: none;\n                        }\n                    }\n\n                    .nepali-text {\n                        font-size: 0.95rem;\n                    }\n\n                    .table-input {\n                        max-width: 100%;\n                        padding: 8px 12px;\n                        font-size: 0.95rem;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.store-form {\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    padding: 35px;\n    border-radius: 15px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08), 0 4px 15px rgba(52, 152, 219, 0.1);\n    border: 2px solid #e3f2fd;\n    transition: all 0.3s ease;\n\n    &:hover {\n        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(52, 152, 219, 0.15);\n    }\n}\n\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 20px;\n    margin-bottom: 30px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    &.full-width {\n        grid-column: 1 / -1;\n    }\n\n    label {\n        margin-bottom: 8px;\n        font-weight: 600;\n        color: #34495e;\n        font-size: 0.9rem;\n        text-align: left;\n    }\n\n    input,\n    textarea {\n        padding: 14px 16px;\n        border: 2px solid #e0e0e0;\n        border-radius: 8px;\n        font-size: 1rem;\n        transition: all 0.3s ease;\n        background: #ffffff;\n        color: #2c3e50;\n        box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n\n        &:hover {\n            border-color: #bdc3c7;\n            box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);\n        }\n\n        &:focus {\n            outline: none;\n            border-color: #3498db;\n            background: #ffffff;\n            box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.15), inset 0 1px 3px rgba(0, 0, 0, 0.05);\n            transform: translateY(-1px);\n        }\n    }\n\n    textarea {\n        resize: vertical;\n        min-height: 80px;\n    }\n\n    input[name=\"miti\"],\n    input[name=\"miti_nepali\"] {\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n        \n        &::placeholder {\n            color: #95a5a6;\n            font-style: italic;\n        }\n    }\n    \n    input[name=\"miti_nepali\"] {\n        padding-right: 45px;\n    }\n    \n    .calendar-btn {\n        position: absolute;\n        right: 8px;\n        top: 65%;\n        transform: translateY(-50%);\n        background: none;\n        border: none;\n        font-size: 1.1rem;\n        cursor: pointer;\n        padding: 8px;\n        border-radius: 4px;\n        transition: background-color 0.2s ease;\n        z-index: 10;\n        \n        &:hover {\n            background-color: #f0f0f0;\n        }\n    }\n    \n    .readonly-input {\n        background-color: #f8f9fa !important;\n        color: #6c757d !important;\n        cursor: not-allowed;\n        \n        &:focus {\n            border-color: #d5d5d5 !important;\n            box-shadow: none !important;\n        }\n    }\n\n    .input-hint {\n        color: #7f8c8d;\n        font-size: 0.8rem;\n        font-style: italic;\n        margin-top: 4px;\n        padding: 4px 8px;\n        background: #ecf0f1;\n        border-radius: 4px;\n        border-left: 3px solid #3498db;\n        line-height: 1.3;\n    }\n    \n    .calendar-popup {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        right: 0;\n        z-index: 1000;\n        background: white;\n        border: 2px solid #3498db;\n        border-radius: 8px;\n        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n        margin-top: 5px;\n    }\n    \n    .help-text {\n        font-size: 0.75rem;\n        color: #7f8c8d;\n        margin-top: 4px;\n        font-style: italic;\n    }\n    \n    &.date-field {\n        margin-bottom: 0;\n    }\n}\n\n.form-actions {\n    display: flex;\n    gap: 15px;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.submit-btn,\n.reset-btn {\n    padding: 12px 30px;\n    border: none;\n    border-radius: 6px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-width: 120px;\n}\n\n.submit-btn {\n    background: #3498db;\n    color: white;\n    font-weight: 600;\n\n    &:hover {\n        background: #2980b9;\n        transform: translateY(-2px);\n        box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);\n    }\n\n    &:disabled {\n        background: #bdc3c7;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n    }\n}\n\n.reset-btn {\n    background: #95a5a6;\n    color: white;\n    font-weight: 600;\n\n    &:hover {\n        background: #7f8c8d;\n        transform: translateY(-2px);\n        box-shadow: 0 4px 8px rgba(149, 165, 166, 0.3);\n    }\n}\n\n.message {\n    padding: 10px;\n    border-radius: 4px;\n    margin: 10px 0;\n    text-align: center;\n    font-weight: 500;\n\n    &.success {\n        background: #d5f4e6;\n        color: #27ae60;\n        border: 1px solid #a8e6cf;\n    }\n\n    &.error {\n        background: #fadbd8;\n        color: #e74c3c;\n        border: 1px solid #f1948a;\n    }\n}\n\n@media (max-width: 768px) {\n    .store-form-container {\n        padding: 10px;\n\n        .form-header {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 10px;\n\n            h2 {\n                font-size: 1.5rem;\n            }\n\n            .storage-controls {\n                width: 100%;\n                justify-content: flex-start;\n                gap: 8px;\n\n                .restore-btn,\n                .save-btn {\n                    padding: 6px 12px;\n                    font-size: 0.8rem;\n                }\n            }\n        }\n    }\n    \n    .store-form {\n        padding: 20px;\n    }\n    \n    .form-grid {\n        grid-template-columns: 1fr;\n        gap: 15px;\n    }\n    \n    .form-actions {\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    .submit-btn,\n    .reset-btn {\n        width: 100%;\n        max-width: 300px;\n    }\n}\n\n@media (max-width: 480px) {\n    .store-form {\n        padding: 15px;\n    }\n    \n    .form-group {\n        input,\n        textarea {\n            padding: 10px;\n            font-size: 0.9rem;\n        }\n        \n        label {\n            font-size: 0.8rem;\n        }\n    }\n}\n\n.edit-mode-indicator {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 8px 12px;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    animation: pulse 2s infinite;\n}\n\n.saved-indicator {\n    background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);\n    color: white;\n    padding: 8px 12px;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes pulse {\n    0% { opacity: 1; }\n    50% { opacity: 0.8; }\n    100% { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"store-form-container": `StoreForm_store-form-container__DSkVI`,
	"form-header": `StoreForm_form-header__cER0m`,
	"storage-controls": `StoreForm_storage-controls__SBjhe`,
	"unsaved-indicator": `StoreForm_unsaved-indicator__uAgWq`,
	"pulse": `StoreForm_pulse__S3Wb8`,
	"last-saved": `StoreForm_last-saved__yiAKp`,
	"restore-btn": `StoreForm_restore-btn__dHLgW`,
	"save-btn": `StoreForm_save-btn__ZLXd6`,
	"template-btn": `StoreForm_template-btn__QxYy8`,
	"upload-btn": `StoreForm_upload-btn__OfvY5`,
	"upload-section": `StoreForm_upload-section__0qzAN`,
	"uploading": `StoreForm_uploading__M4Ky2`,
	"upload-status": `StoreForm_upload-status__lQhM3`,
	"success": `StoreForm_success__8Nvdd`,
	"error": `StoreForm_error__X1b3K`,
	"official-header": `StoreForm_official-header__keK1W`,
	"header-top": `StoreForm_header-top__dQNUI`,
	"header-left": `StoreForm_header-left__dbz14`,
	"university-name": `StoreForm_university-name__uGHzX`,
	"office-name": `StoreForm_office-name__ojrno`,
	"office-code": `StoreForm_office-code__I+dIJ`,
	"code-value": `StoreForm_code-value__lwWbo`,
	"header-right": `StoreForm_header-right__FmV2V`,
	"form-number": `StoreForm_form-number__inyUw`,
	"header-input": `StoreForm_header-input__Ue+fr`,
	"previous-form": `StoreForm_previous-form__21s8i`,
	"main-title": `StoreForm_main-title__HpFHU`,
	"sub-header": `StoreForm_sub-header__1ozvf`,
	"fiscal-year": `StoreForm_fiscal-year__Cg3Mf`,
	"inventory-info": `StoreForm_inventory-info__IBcs4`,
	"table-header": `StoreForm_table-header__ytNyh`,
	"table-row": `StoreForm_table-row__necnr`,
	"table-cell": `StoreForm_table-cell__p29+a`,
	"nepali-text": `StoreForm_nepali-text__GO5hX`,
	"english-text": `StoreForm_english-text__5XRwp`,
	"table-input": `StoreForm_table-input__4b8fS`,
	"store-form": `StoreForm_store-form__TezP0`,
	"form-grid": `StoreForm_form-grid__LeD44`,
	"form-group": `StoreForm_form-group__uSERQ`,
	"full-width": `StoreForm_full-width__zCoGK`,
	"calendar-btn": `StoreForm_calendar-btn__tb-va`,
	"readonly-input": `StoreForm_readonly-input__tbHDv`,
	"input-hint": `StoreForm_input-hint__r7aYd`,
	"calendar-popup": `StoreForm_calendar-popup__DhUqu`,
	"help-text": `StoreForm_help-text__NrAlX`,
	"date-field": `StoreForm_date-field__RqIlt`,
	"form-actions": `StoreForm_form-actions__yQd7T`,
	"submit-btn": `StoreForm_submit-btn__CjfnF`,
	"reset-btn": `StoreForm_reset-btn__-H-mq`,
	"message": `StoreForm_message__Uoi4h`,
	"edit-mode-indicator": `StoreForm_edit-mode-indicator__yH07a`,
	"saved-indicator": `StoreForm_saved-indicator__-3IQK`
};
export default ___CSS_LOADER_EXPORT___;
